module.exports = __webpack_public_path__ + "static/media/01B.a6ac41e5.png";